import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { isServerSide, standardCheckoutRoutes } from "@jti/fe-common";
import { getSessionStorage, getUser } from "@jti/rest-api";
import { clearFreeGiftsErrors, redirectToAuthWithBack, selectQtyPending, selectShouldShowLoyaltyReminderDialog, standardCheckoutForm, useDispatch, useSelector, } from "@jti/store";
import { LoyaltyReferralCode, LoyaltyReminderDialog, TrustPilotMicroReviewCount, useConfig, useLoyaltyReminderDialog, useTranslations, } from "@jti/ui";
import { CartPaymentSummary } from "../../../../components/CartPaymentSummary";
import { CartPoints } from "../../../../components/CartPoints";
import PricesFooter from "../../../../components/PricesFooter";
import { PromoCode } from "../../../../components/PromoCode";
import { SummarySubscription } from "../../../../components/SummarySubscription";
import { useAemModel } from "../../../../contexts/AemModelContext";
import { useLoyaltyCustomerState } from "../../../../hooks/useLoyaltyCustomerState";
import { useLoyaltyProductPoints } from "../../../../hooks/useLoyaltyProductPoints";
import { useSyncReferralStatus } from "../../../../hooks/useSyncReferralStatus";
import { AsideLayout } from "../../../../layouts/AsideLayout";
import { categorizeItems } from "../../../../utils/categorizeItems";
import getCartItemsCount from "../../../../utils/getCartItemsCount";
import { useIsCheckoutBlockedByTradeIn } from "../hooks/useIsCheckoutBlockedByTradeIn";
import styles from "./CartPageAside.module.scss";
export const CartPageAside = ({ isCartItemsLimitReached, isAgeVerificationErrorVisible }) => {
    useLoyaltyCustomerState();
    useSyncReferralStatus();
    const history = useHistory();
    const dispatch = useDispatch();
    const { __ } = useTranslations();
    const { loyalty } = useAemModel();
    const config = useConfig();
    const user = getUser();
    const { promoCode } = useSelector((store) => store.cart);
    const freeTrialID = useSelector((store) => store.freeTrialCart.id);
    const items = useSelector((state) => state.cart.items);
    const itemsCount = getCartItemsCount(items);
    const hasOutOfStockItems = useSelector((state) => state.cart.items.some(({ status }) => status === "OUT_OF_STOCK"));
    const qtyPending = useSelector(selectQtyPending);
    const shouldShowReminderDialog = useSelector(selectShouldShowLoyaltyReminderDialog);
    const isBlockedByTradeIn = useIsCheckoutBlockedByTradeIn();
    const totalLoyaltyPoints = useLoyaltyProductPoints(items);
    const { isOpen: isReminderDialogOpen, open: openReminderDialog, close: closeReminderDialog, } = useLoyaltyReminderDialog();
    const { subscriptionItems } = categorizeItems(items);
    const shouldRenderPromoCodeBlock = !config.hidePromoCodeBlockOnCheckoutLandingPage && itemsCount > 0 && promoCode.isVisible;
    const startCheckoutProcess = useCallback(() => {
        if (!user?.email) {
            redirectToAuthWithBack();
            return;
        }
        getSessionStorage().set("loyaltyCartPoints", totalLoyaltyPoints);
        dispatch(standardCheckoutForm.actions.setReady());
        history.push(standardCheckoutRoutes.shipping);
    }, [user?.email, totalLoyaltyPoints, dispatch, history]);
    const onLoyaltyReminderPrimaryButtonClick = useCallback(() => {
        closeReminderDialog();
        startCheckoutProcess();
    }, [closeReminderDialog, startCheckoutProcess]);
    const onLoyaltyReminderSecondaryButtonClick = useCallback(() => {
        closeReminderDialog();
        if (!isServerSide() && loyalty.reminderDialogSecondaryButtonLink) {
            window.location.href = loyalty.reminderDialogSecondaryButtonLink;
        }
    }, [closeReminderDialog, loyalty.reminderDialogSecondaryButtonLink]);
    const onCheckoutButtonClick = useCallback(() => {
        const shouldShowLoyaltyReminderDialog = loyalty.showReminderDialog && shouldShowReminderDialog && user?.email;
        if (shouldShowLoyaltyReminderDialog) {
            openReminderDialog();
            return;
        }
        startCheckoutProcess();
        dispatch(clearFreeGiftsErrors());
    }, [loyalty.showReminderDialog, shouldShowReminderDialog, user?.email, openReminderDialog, startCheckoutProcess]);
    const onReferralCodeApplied = () => {
        if (isServerSide()) {
            return;
        }
        window.location.href = window.location.href.split("#")[0];
    };
    return (_jsxs(_Fragment, { children: [_jsx(AsideLayout, { "data-testid": "regularCartSummaryBlock", slot4: _jsxs(_Fragment, { children: [!freeTrialID && loyalty.showMgm ? (_jsx("div", { className: styles.mgmWrapper, children: _jsx(LoyaltyReferralCode, { onCodeApplied: onReferralCodeApplied }) })) : null, shouldRenderPromoCodeBlock ? _jsx(PromoCode, {}) : null] }), paymentSummarySlot: _jsx(CartPaymentSummary, {}), slot1: _jsx(CartPoints, { totalPointsCount: totalLoyaltyPoints }), slot0: subscriptionItems.length > 0 ? (_jsx(SummarySubscription, { items: subscriptionItems, isCollapsible: false, showProductList: false })) : null, slot2: _jsxs(_Fragment, { children: [_jsx(PricesFooter, { disabled: isBlockedByTradeIn ||
                                hasOutOfStockItems ||
                                isCartItemsLimitReached ||
                                isAgeVerificationErrorVisible ||
                                !itemsCount ||
                                qtyPending, onCheckout: onCheckoutButtonClick }), _jsx(TrustPilotMicroReviewCount, { className: styles.trustPilotWidget })] }) }), loyalty.showReminderDialog && shouldShowReminderDialog && (_jsx(LoyaltyReminderDialog, { isOpened: isReminderDialogOpen, title: loyalty.reminderDialogTitle, subtitle: loyalty.reminderDialogSubtitle, text: loyalty.reminderDialogText, primaryButtonText: __("cart.button.proceed_to_checkout"), secondaryButtonText: loyalty.reminderDialogSecondaryButtonText, onPrimaryButtonClick: onLoyaltyReminderPrimaryButtonClick, onSecondaryButtonClick: onLoyaltyReminderSecondaryButtonClick, onClose: closeReminderDialog }))] }));
};
//# sourceMappingURL=CartPageAside.js.map